// show first content pane on load
$('#tabContentWithSliders .tab-pane').first().tab('show');

// show first slide on load
var slideContainer = $('#tabContentWithSliders .carousel-inner');
$.each(slideContainer, function () {
  $(this).find('.carousel-item').first().addClass('active');
});
